const initials = "dashboard/";

export const UPDATE_DASHBOARD_RESULT = `${initials}UPDATE_DASHBOARD_RESULT`;
export const UPDATE_DASHBOARD_MAPPING = `${initials}UPDATE_DASHBOARD_MAPPING`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;
export const UPDATE_MAPPING_FILTER = `${initials}UPDATE_MAPPING_FILTER`;
export const UPDATE_MAPPING_REDUCER = `${initials}UPDATE_MAPPING_REDUCER`;
export const UPDATE_DASHBOARD_DATA = `${initials}UPDATE_DASHBOARD_DATA`